module.exports = __webpack_public_path__ + "static/img/news4detail5.1b396c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4detail5.jpg
// module id = bMNx
// module chunks = 0